
import { Component, Vue, Watch } from "vue-property-decorator";
import {
  IDefaultShippingOrderModel,
  ITypeModel,
  IUserModel,
} from "@/api/types";
import Pagination from "@/components/Pagination/index.vue";
import { Form, Message } from "element-ui";
import { createCustomerWhole, searchCustomer } from "@/api/customer";

// import { cloneDeep } from "lodash";
import { getContainerType } from "@/api/container-type";
import { QuotationApproval } from "./types";
import { getUsersByJobPosition } from "@/api/users";
import {getAbnormalDeliveryState, getAbnormalDelivery, downloadExcDeliveryInfo} from "@/api/proforma";
import {
  getQuotationList,
  getSalesmanList,
  auditHold,
  removeQuotation,
  getQuotationStatus,
  generatePI,
  auditPass,
  getSuppliersList,
} from "@/api/inquiry";
import { Moment } from "moment";
import { ShippingOrderModel } from "@/model/shipping-order";
import { COMPANY_OPTIONS } from "@/constant";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";

@Component({
  name: "AbnormalDeliveryHandling",
  components: {
    Pagination,
    Quantity: () => import("./components/Quantity.vue"),
    Stock: () => import("./components/Stock.vue"),
  },
})
export default class extends Vue {
  private id = "";
  private total = 0;
  private listLoading = true;
  private showQuantity = false;
  private showStock = false;
  private selectedItem = {} as any;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public listParam = {
    modelNumber: null,
    hqProductName: null,
    productName: null,
    supplier: null,
    status: null,
  };
  public searchForm = [
    {
      label: "号码查询",
      prop: "modelNumber",
      key: "modelNumber",
      type: "input",
      value: "",
      placeholder: "请输入产品号码",
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      type: "input",
      value: "",
      placeholder: "请输入华强品名",
    },
    {
      label: "PRODUCT NAME",
      prop: "productName",
      key: "productName",
      type: "input",
      options: [],
      value: "",
      placeholder: "请输入PRODUCT NAME",
    },
    {
      label: "供应商",
      prop: "supplier",
      key: "supplier",
      type: "select",
      value: "",
      placeholder: "",
      remote_method: this.getSuppliersList,
      remote: true,
      clearable: true,
      options: [],
      resetKey: { label: "abbreviation", value: "id" },
    },
    {
      label: "交货状态",
      prop: "status",
      key: "status",
      type: "select",
      value: "",
      options: [],
      placeholder: "全部",
      resetKey: { label: "desc", value: "name" },
    },
  ];
  public tableCol = [
    {
      label: "S/N",
      prop: "sn",
      key: "sn",
      show: true,
      fixed: true,
      disabled: false,
      icon: require("@/assets/images/ic_chaofa.png"),
      icon_key: "status",
      icon_value: "OVERDELIVERY",
      icon2: require("@/assets/images/ic_qianfa.png"),
      icon_key2: "status",
      icon_value2: "UNDERDELIVERY",
    },
    {
      label: "询价参照号",
      prop: "inquiryRefNumber",
      key: "inquiryRefNumber",
      fixed: true,
      show: true,
      disabled: false,
      width: "150",
    },
    {
      label: "号码类型",
      prop: "inquiryRefType",
      key: "inquiryRefType",
      show: true,
      disabled: false,
    },

    {
      label: "PRODUCT NAME",
      prop: "productName",
      key: "productName",
      show: true,
      disabled: false,
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false,
    },
    {
      label: "采购订单号",
      prop: "purchaseOrderCode",
      key: "purchaseOrderCode",
      show: true,
      disabled: false,
    },
    {
      label: "接单数量",
      prop: "shipmentQuantity",
      key: "shipmentQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "下单数量",
      prop: "orderQuantity",
      key: "orderQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "交货数量",
      prop: "goodsEnterdQuantity",
      key: "goodsEnterdQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "异常数量",
      prop: "overdueQuantity",
      key: "overdueQuantity",
      show: true,
      disabled: false,
    },
    {
      label: "装箱单号",
      prop: "hqPackingListCode",
      key: "hqPackingListCode",
      show: true,
      disabled: false,
    },
    {
      label: "产品单位",
      prop: "productUnit",
      key: "productUnit",
      show: true,
      disabled: false,
    },
    {
      label: "供应商",
      prop: "supplierName",
      key: "supplierName",
      show: true,
      disabled: false,
    },
    {
      label: "销售总价",
      prop: "saleTotalAmount",
      key: "saleTotalAmount",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "管理交货数量",
          code: "",
          click: "handleQuantity",
          key: "status",
          value: "OVERDELIVERY",
        },
        {
          name: "使用客人库存",
          code: "",
          click: "handleQuantity",
          key: "status",
          value: "UNDERDELIVERY",
        },
      ],
      show: true,
      disabled: false,
      width: 260,
    },
  ] as any;

  created() {
    this.id = (this.$route.query.id as string) || "";
    this.init();
  }

  activated() {
    this.init();
  }

  private init() {
    this.getAbnormalDeliveryState();
    // this.getSalesmanList();
    this.getList();
  }

  private async handleSuccess() {
   await this.getList();
  }

  private async getAbnormalDeliveryState() {
    const res: any = await getAbnormalDeliveryState();
    this.searchForm[4].options = res;
  }

  private async getSuppliersList(name = "") {
    const res: any = await this.getSuppliers(name);
    this.searchForm[3].options = res;
  }

  private async getSuppliers(name = "") {
    const res: any = await getSuppliersList({ abbreviation: name });
    return res;
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = false;
    const res: any= await getAbnormalDelivery(this.id, params);
    this.table.total = Number(res.total)
    this.table.list = res.list;
    if (this.table.total > 0) {
      this.table.list.forEach((item, index) => {
        item.sn = index + 1;
      });
    }
    this.loading = false;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  //  删除
  public async handleDelete(scope) {
    await removeQuotation({
      detailId: scope.row.approvalRecordId,
    });
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  // 审批通过
  public async handleAuditPass(scope) {
    this.$confirm("确定审批通过吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await auditPass(scope.row.approvalRecordId);
        this.$notify({
          title: "成功",
          message: "审批通过",
          type: "success",
          duration: 2000,
        });
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  //   使用客人库存
  private handleStock(scope) {
    this.selectedItem = scope.row;
    this.showStock = true;
  }

  //   管理交货数量
  private handleQuantity(scope) {
    this.selectedItem = scope.row;
    this.showQuantity = true;
  }

  public querySearch(data) {
    const params = Object.assign({}, data);
    const { ...rest } = params;
    this.listParam = rest;
    this.table.pageNumber = 1;
    this.getList();
  }

  private linkClick(scope) {
    let item = JSON.stringify(scope.row);
    if (item.indexOf("&") != -1) {
      item = item.replace("&", "replace");
    }
    this.$router.push(
      `/quotationDetails?id=${scope.row.inquirySheetId}&item=${item}`
    );
  }

  private async download() {
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    try {
    await downloadExcDeliveryInfo(this.id,params);
    }catch (error) {
      console.error(error);
    }
  }
}
